import axios from 'axios';
import { ScriveSignersTabModel, WorkflowDataSourceModel, WorkflowJobProcessResultModel } from '@/types';

const SignerTabApiUrl = 'scrive/scriveSignersTab/';

export const ScriveSignersTabService = {
  async getScriveSignersTabAsync(jobId: number): Promise<ScriveSignersTabModel> {
    const response = await axios.get(`${SignerTabApiUrl}${jobId}`);
    return response.data;
  },
  async updateScriveSignersTabDataSourceAsync(jobId: number, scriveSignersDataSource: WorkflowDataSourceModel) {
    await axios.post(`${SignerTabApiUrl}${jobId}`, scriveSignersDataSource);
  },
  async sendScriveDocumentForSigningAsync(jobId: number, scriveSignersDataSource: WorkflowDataSourceModel): Promise<WorkflowJobProcessResultModel> {
    const result = await axios.post(`${SignerTabApiUrl}sendforsigning/${jobId}`, scriveSignersDataSource);
    return result.data;
  }
};
